var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "c-outage-result__lv",
      class: {
        "c-outage-result__lv--list-view": _vm.outagePageView === "list",
      },
    },
    [
      _c("div", { staticClass: "c-outage-result__wrapper" }, [
        _c(
          "div",
          { staticClass: "c-outage-result__details" },
          [
            _c("p", { staticClass: "c-outage-result__outage-number" }, [
              _vm._v(
                "\n        " +
                  _vm._s("#" + _vm.lvOutageProperties.csvSuburbID) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("h3", { staticClass: "c-outage-result__outage-title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.lvOutageProperties.csvSuburb) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "c-outage-result__outage-type",
                class:
                  "c-outage-result__outage-type--" +
                  _vm.statusToClass(_vm.lvOutageProperties.csvStatus),
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.statusToPublicName(_vm.lvOutageProperties.csvStatus)
                    ) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.lvOutageProperties.csvStatus == "All Restored"
              ? [
                  _c("p", { staticClass: "c-outage-result__update" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.lvOutageProperties.csvTotalClosedIncidents) +
                        " affected customers.\n        "
                    ),
                  ]),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.lvOutageProperties.csvStatus == "In Progress" ||
            _vm.lvOutageProperties.csvStatus == "Not Started"
              ? [
                  _c("p", { staticClass: "c-outage-result__start-time" }, [
                    _vm._v(
                      "\n          Estimated start date/time:\n          "
                    ),
                    _c("span", { staticClass: "c-outage-result__bold" }, [
                      _vm._v(
                        _vm._s(_vm.lvOutageProperties.csvAttendanceWindowStart)
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "c-outage-result__start-time" },
                    [
                      _vm.lvOutageProperties.csvAttendanceWindowEnd
                        ? [
                            _vm._v(
                              "\n            Estimated restoration:\n            "
                            ),
                            _c(
                              "span",
                              { staticClass: "c-outage-result__bold" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.lvOutageProperties
                                      .csvAttendanceWindowEnd
                                  )
                                ),
                              ]
                            ),
                          ]
                        : [
                            _vm._v(
                              "\n            Estimated time of restoration to be confirmed.\n          "
                            ),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.lvOutageProperties.csvStatus == "In Progress"
                    ? _c("p", { staticClass: "c-outage-result__start-time" }, [
                        _vm._v(
                          "\n          Total resolved incidents\n          "
                        ),
                        _c("span", { staticClass: "c-outage-result__bold" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.lvOutageProperties.csvTotalClosedIncidents
                              )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", { staticClass: "c-outage-result__update" }, [
                    _vm._v(
                      "\n          We have " +
                        _vm._s(_vm.lvOutageProperties.csvTotalOpenIncidents) +
                        " affected\n          customers.\n        "
                    ),
                  ]),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("p", { staticClass: "c-outage-result__last-updated" }, [
              _vm._v(_vm._s(_vm.lastUpdated())),
            ]),
            _vm._v(" "),
            _vm.outagePageView == "map"
              ? _c(
                  "span",
                  {
                    staticClass: "c-outage-result__zoom",
                    on: {
                      click: function ($event) {
                        return _vm.zoomToMap(_vm.lvOutage)
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: "_resources/app/client/assets/icons/outages-map/map-icon.svg",
                      },
                    }),
                  ]
                )
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }